import { useTranslation } from 'react-i18next';
import Header from "../components/Header/Header";

function MentionsLegales() {
    const { t } = useTranslation();
    return (
        <div>
            <Header title={t('mentionsLegales.title')} printPicture="true"/>

            <div className="mentions-legales">
                <h3>{t('mentionsLegales.editorTitle')}</h3>
                <p>{t('mentionsLegales.editorText')} <u>{t('mentionsLegales.editorName')}</u></p>
                <p>{t('mentionsLegales.emailLabel')} <a href="mailto:brieucjoonn@gmail.com">brieucjoonn@gmail.com</a></p>

                <h3>{t('mentionsLegales.hostingTitle')}</h3>
                <p>{t('mentionsLegales.hostingText')}</p>
                <p>{t('mentionsLegales.hostingAddress')}</p>
                <p>{t('mentionsLegales.hostingPhone')}</p>
                <p>{t('mentionsLegales.hostingWebsite')} <a href="www.ovh.com">www.ovh.com</a></p>

                <h3>{t('mentionsLegales.dataTitle')}</h3>
                <p>{t('mentionsLegales.dataText')}</p>

                <h3>{t('mentionsLegales.responsibilityTitle')}</h3>
                <p>{t('mentionsLegales.responsibilityText')}</p>
            </div>
        </div>
    );
  }

  export default MentionsLegales;
